import React, { useState, useEffect } from 'react';

import PerfectScrollbar from 'react-perfect-scrollbar';
import makeStyles from '@material-ui/core/styles/makeStyles';

import CmtVertical from '../../../../../../@coremat/CmtNavigation/Vertical';
import { menusSection } from '../../../partials/menus.dynamic.header';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
// import { sidebarNavs } from '../menus';

const useStyles = makeStyles(() => ({
  perfectScrollbarSidebar: {
    height: '100%',
    transition: 'all 0.3s ease',
    '.Cmt-sidebar-fixed &, .Cmt-Drawer-container &': {
      height: 'calc(100% - 167px)',
    },
    '.Cmt-modernLayout &': {
      height: 'calc(100% - 72px)',
    },
    '.Cmt-miniLayout &': {
      height: 'calc(100% - 91px)',
    },
    '.Cmt-miniLayout .Cmt-sidebar-content:hover &': {
      height: 'calc(100% - 167px)',
    },
  },
}));

const SideBar = () => {
  const classes = useStyles();
  const { user } = useSelector(({ claveUnica }) => claveUnica);
  const [menu, setMenu] = useState([]);
  const location = useLocation();

  useEffect(() => {
    var auxUser = {};
    try {
      auxUser = JSON.parse(user);
    } catch (error) {
      auxUser = user;
    }
    setMenu(menusSection(auxUser, location.pathname));
  }, [user, location]);

  return (
    <PerfectScrollbar className={classes.perfectScrollbarSidebar}>
      {menu && <CmtVertical menuItems={menu} />}
    </PerfectScrollbar>
  );
};

export default SideBar;
